import React from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import type { LatLngExpression } from "leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
});

const path: LatLngExpression[] = [
    [23.8103, 90.4125],
    [23.7806, 90.4074],
    [23.7500, 90.4000],
    [23.7000, 90.3700],
    [23.5000, 90.2500],
];

function MapUpdater({ center, zoom }: { center: LatLngExpression; zoom: number }) {
    const map = useMap();
    React.useEffect(() => {
        map.setView(center, zoom);
    }, [center, zoom, map]);
    return null;
}

export default function LiveLocationDemo() {
    const lastPosition = path[path.length - 1];

    return (
        <div className={"pt-2"} style={{ height: "300px", width: "100%" }}>
            <MapContainer style={{ height: "100%", width: "100%" }}>
                <MapUpdater center={lastPosition} zoom={8} />
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                {path.map((pos, idx) => (
                    <Marker key={idx} position={pos}>
                        <Popup>
                            {idx === path.length - 1
                                ? "Current Location (Pushed)"
                                : `Location ${idx + 1}`}
                        </Popup>
                    </Marker>
                ))}
            </MapContainer>
        </div>
    );
}
